import { css } from '@compiled/react';

import Spinner from '@atlaskit/spinner';

const loadingSpinnerCss = css({
	alignItems: 'center',
	display: 'flex',
	justifyContent: 'center',
	minHeight: '50vh',
});

export const JiraSoftwarePageLoadingSpinner = () => {
	return (
		<div
			css={loadingSpinnerCss}
			role="progressbar"
			aria-label="Loading Jira site"
			data-testid="jira-software-page-loading-spinner"
		>
			<Spinner size="large" />
		</div>
	);
};
